/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EsgConsolidationNarrativeAiResponse } from '../../models/esg-consolidation-narrative-ai-response';
import { EsgDisclosureCode } from '../../models/esg-disclosure-code';
import { EsgDisclosureDatapointId } from '../../models/esg-disclosure-datapoint-id';

export interface ConsolidationAiRetrieveStatusByResponseId$Params {
  profileId: number;
  year: number;
  code: EsgDisclosureCode;
  dataPointId: EsgDisclosureDatapointId;
  responseId: string;
}

export function consolidationAiRetrieveStatusByResponseId(http: HttpClient, rootUrl: string, params: ConsolidationAiRetrieveStatusByResponseId$Params, context?: HttpContext): Observable<StrictHttpResponse<EsgConsolidationNarrativeAiResponse>> {
  const rb = new RequestBuilder(rootUrl, consolidationAiRetrieveStatusByResponseId.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('year', params.year, {});
    rb.path('code', params.code, {});
    rb.path('dataPointId', params.dataPointId, {});
    rb.path('responseId', params.responseId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EsgConsolidationNarrativeAiResponse>;
    })
  );
}

consolidationAiRetrieveStatusByResponseId.PATH = '/esg/profile/consolidation/{profileId}/{year}/{code}/datapoint/{dataPointId}/narrative-ai/{responseId}';
